module.exports = __webpack_public_path__ + "img/close-menu-icon.6762b9fd.svg";